import { render } from "./ColorGuide.vue?vue&type=template&id=23fe869c&scoped=true"
import script from "./ColorGuide.vue?vue&type=script&lang=js"
export * from "./ColorGuide.vue?vue&type=script&lang=js"

import "./ColorGuide.vue?vue&type=style&index=0&id=23fe869c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fe869c"]])

export default __exports__